export const GAtracker = {
  record,
  init
};
let category = null;

function record(action, label) {
  if (
    window.location.hostname === 'localhost' &&
    category !== null
  ) {
    console.log(category, action, label);
  }

  if (category !== null) {
    window.ga('send', 'event', category, action, label);
  }
}

function init(data) {
  if (typeof data !== 'undefined') {
    category = data.category;
    window.ga('create', data.id);
    window.ga('send', 'pageview');
  }
}
